<template>
	<div
		v-if="isLoggedIn"
		class="user-profile-picture"
		:style="userProfileStyle"
	>
		{{ placeholderPicture }}
	</div>
</template>

<style scoped>
.user-profile-picture {
	border-radius: 50%;
	font-size: 16px;
	color: var(--gR-white);
	font-weight: 600;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>

<script>
export default {
	name: "UserPicture",
	props: {
		size: {
			type: Number,
			default: 0
		}
	},
	computed: {
		isLoggedIn() {
			return this.$store.state.user && this.$store.state.user.id != 0
		},
		hasProfilePicture() {
			return (
				this.$store.state.user.picture &&
				this.$store.state.user.picture != ""
			)
		},
		placeholderPicture() {
			const firstInitial =
				this.$store.state.user.username.length > 0
					? this.$store.state.user.username[0]
					: ""
			return this.hasProfilePicture ? "" : firstInitial
		},
		userProfileStyle() {
			const pixelSize = `${this.size}px`
			if (this.hasProfilePicture) {
				return {
					width: pixelSize,
					height: pixelSize,
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundImage: `url(${this.$store.state.user.picture})`
				}
			}
			return {
				lineHeight: pixelSize,
				width: pixelSize,
				height: pixelSize,
				backgroundColor: "var(--gR-base-90)"
			}
		}
	}
}
</script>